import { Component, EventEmitter, Input, Output, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VehicleModelService } from '../services/vehicle-model.service';
import Swal from 'sweetalert2';
import { CommonService } from 'src/app/shared/service/common/common.service';
import { CountryCmbDto } from 'src/app/shared/dto/country.dto';
import { StateDto, CityDto } from 'src/app/shared/dto/city.dto';
import { CreateVehicleDTO } from '../vehicle';

@Component({
  selector: 'app-modal-vehicle-edit',
  templateUrl: './modal-vehicle-edit.component.html',
  styleUrls: ['./modal-vehicle-edit.component.css'],
})
export class ModalVehicleEditComponent implements OnInit {
  @Input() selectedVehicle: any;
  @Output() close = new EventEmitter<void>();
  @ViewChild('modal21') modal21: any;

  vehicleForm: FormGroup = new FormGroup({});
  listVehicleTypesAll: any[] = [];
  countries: CountryCmbDto[] = [];
  states: StateDto[] = [];
  cities: CityDto[] = [];
  showModal: boolean = true;

  constructor(
    private fb: FormBuilder,
    private vehicleService: VehicleModelService,
    private readonly commonService: CommonService,
  ) {
    // do nothing
  }

  ngOnInit(): void {
    // console.log(this.selectedVehicle);
    this.vehicleForm = this.fb.group({
      typevehicle: [this.selectedVehicle?.typevehicle, Validators.required],
      brand: [this.selectedVehicle?.brand, Validators.required],
      modelo: [this.selectedVehicle?.modelo, Validators.required],
      km: [this.selectedVehicle?.km, [Validators.required]],
      plate: [this.selectedVehicle?.plate, Validators.required],
      color: [this.selectedVehicle?.color, Validators.required],
      year: [this.selectedVehicle?.year, Validators.required],
      country: [this.selectedVehicle?.country?.code, Validators.required],
      state: [this.selectedVehicle?.state?.code, Validators.required],
      city: [this.selectedVehicle?.city?.code, Validators.required],
    });

    this.getlistVehicleTypesAll();
    this.getAvailableCountriesToCmb();
  }

  async getAvailableCountriesToCmb() {
    this.countries = await this.commonService.getAvailableCountriesToCmb();
    this.onPaisChange();
  }

  async onPaisChange() {
    this.states = await this.commonService.getAvailableStatesByCountryCode(this.vehicleForm.get('country')?.value);
    this.vehicleForm.patchValue({ state: '', city: '' });
  }

  async onStateChange() {
    this.cities = await this.commonService.getAvailableCityByStateCountryCode(this.vehicleForm.get('country')?.value, this.vehicleForm.get('state')?.value);
    this.vehicleForm.patchValue({ city: '' });
  }

  async updateVehicle(): Promise<void> {
    if (this.vehicleForm.valid) {
      const formValue = this.vehicleForm.value;

      // Obtener los objetos completos de país, estado y ciudad
      const selectedCountry = this.countries.find((country) => country.cca2 === formValue.country);
      const selectedState = this.states.find((state) => state.state_code === formValue.state);
      const selectedCity = this.cities.find((city) => city.city_code === formValue.city);

      const vehicleData: CreateVehicleDTO = {
        brand: formValue.brand,
        year: formValue.year,
        typevehicle: formValue.typevehicle,
        vehicle_model: formValue.modelo,
        // icon: this.selectedVehicle.icon,

        km: formValue.km,
        city: {
          code: selectedCity?.city_code || '',
          name: selectedCity?.city_name || '',
        },
        state: {
          code: selectedState?.state_code || '',
          name: selectedState?.state_name || '',
        },
        country: {
          code: selectedCountry?.cca2 || '',
          name: selectedCountry?.name.common || '',
        },
      };

      await this.vehicleService.updateVehicleModel(this.selectedVehicle.id, vehicleData);
      Swal.fire({
        toast: true,
        position: 'top',
        icon: 'success',
        title: '¡Éxito!',
        text: 'Vehículo actualizado correctamente',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        confirmButtonText: 'Aceptar',
      }).then(() => {
        this.closeModal();
      });
    } else {
      //   console.error('Formulario inválido, ¡corrige los errores! 😅');
    }
  }

  closeModal(): void {
    window.location.reload();
    this.close.emit();
  }

  selectColor(color: string): void {
    this.vehicleForm.get('color')?.setValue(color);
  }

  async getlistVehicleTypesAll() {
    const result = (await this.commonService.getlistVehicleTypesAll()).map((option: any) => {
      return {
        _id: option._id,
        name: option.name.es,
      };
    });

    this.listVehicleTypesAll = result;
  }
}
